import React, {useEffect, useState} from "react";
import { Link } from "react-router-dom";
import { FaLock } from "react-icons/fa6";
const AccessDeniedPartial = () => {

  const [redirect, setRedirect] = useState("/");

  useEffect(() => {
    const url = new URL(window.location.href);
 
    if(url.pathname !== "/authorization"){
      setRedirect(url.pathname + url.search);
    }
  }, [])

  const link = () => {
    return(localStorage.getItem("jwt") === null ? <><Link className="text-dark" to={"/authorization?redirect=" + redirect}><strong>Zaloguj się</strong></Link> i pobierz materiały</> : <></>);
  }

  return(
    <div className="text-center mt-5">
      <h2>
        <FaLock /></h2><p><strong>Brak dostępu do zasobów</strong><br/>{link()}</p>
    </div>
  )

}
export default AccessDeniedPartial